module.exports = __webpack_public_path__ + "img/edward-g.-walker.366deadd.png";